import { getGsap, getScrollTrigger } from "../global/GsapGlobals";
import { DUR, EASE, STAGGER, motionOK } from "../global/MotionTokens";

const SECTION_SELECTOR = "[data-theh-why-reveal]";
const GROUP_SELECTOR = "[data-why-reveal-group]";
const ITEM_SELECTOR = "[data-why-reveal-item]";
const MASK_SELECTOR = "[data-why-reveal-mask]";
const MEDIA_SELECTOR = "[data-why-reveal-media]";

export class ThehWhyRevealController {
    static init(): void {
        const sections = Array.from(
            document.querySelectorAll<HTMLElement>(SECTION_SELECTOR),
        );
        if (!sections.length) return;

        sections.forEach((section) => {
            if (section.dataset.thehWhyRevealBound === "1") return;
            section.dataset.thehWhyRevealBound = "1";

            const groups = Array.from(
                section.querySelectorAll<HTMLElement>(GROUP_SELECTOR),
            );
            if (!groups.length) return;

            const masks = Array.from(
                section.querySelectorAll<HTMLElement>(MASK_SELECTOR),
            );

            if (!motionOK()) {
                masks.forEach((mask) => mask.setAttribute("hidden", ""));
                return;
            }

            const gsap = getGsap();
            const ScrollTrigger = getScrollTrigger();
            section.classList.add("is-theh-why-reveal-ready");

            groups.forEach((group, groupIndex) => {
                const items = Array.from(
                    group.querySelectorAll<HTMLElement>(ITEM_SELECTOR),
                );
                const groupMasks = Array.from(
                    group.querySelectorAll<HTMLElement>(MASK_SELECTOR),
                );
                const media = Array.from(
                    group.querySelectorAll<HTMLElement>(MEDIA_SELECTOR),
                );

                gsap.set(items, {
                    y: 28,
                    opacity: 0,
                    willChange: "transform, opacity",
                });

                if (groupMasks.length) {
                    gsap.set(groupMasks, {
                        scaleX: 1,
                        transformOrigin: "right center",
                        willChange: "transform",
                    });
                }

                if (media.length) {
                    gsap.set(media, {
                        scale: 1.035,
                        willChange: "transform",
                    });
                }

                const timeline = gsap.timeline({
                    paused: true,
                    onComplete: () => {
                        groupMasks.forEach((mask) => mask.setAttribute("hidden", ""));
                        gsap.set([...items, ...media], { willChange: "auto" });
                    },
                });

                if (groupMasks.length) {
                    timeline.to(groupMasks, {
                        scaleX: 0,
                        duration: DUR.epic,
                        ease: EASE.inOut,
                    });
                }

                timeline.to(
                    items,
                    {
                        y: 0,
                        opacity: 1,
                        duration: DUR.slower,
                        ease: EASE.outExpo,
                        stagger: STAGGER.slow * 0.55,
                    },
                    groupMasks.length ? 0.16 : 0,
                );

                if (media.length) {
                    timeline.to(
                        media,
                        {
                            scale: 1,
                            duration: DUR.epic,
                            ease: EASE.outQuart,
                        },
                        0,
                    );
                }

                ScrollTrigger.create({
                    trigger: group,
                    start: groupIndex === 0 ? "top 88%" : "top 82%",
                    once: true,
                    invalidateOnRefresh: true,
                    onEnter: () => timeline.play(0),
                });
            });
        });
    }
}
